import React from 'react';

const TextAreaQuestionBlock = ({ question, register, errors }) => {
    return (
        <div className="mb-4">
            <label className="form-label mb-0">
                {question.title} {question.required && "*"}
            </label>
            {question.description && (
                <p className="text-muted"><small>{question.description}</small></p>
            )}
            <textarea
                className="form-control"
                rows={question.rows || 4}
                placeholder={question.placeholder}
                {...register(question.internalId, {
                    required: question.required ? `${question.title} is required` : false,
                })}
            />
            {errors[question.internalId] && (
                <div className="text-danger small">{errors[question.internalId].message}</div>
            )}
        </div>
    );
};

export default TextAreaQuestionBlock;